<template>
  <BaseCard class="weaponCard" :disabled="disabled" :true-value="trueValue" :value="value" :checkbox="checkbox" :clickable="clickable" :check-icon="checkIcon">
    <template v-slot:title>{{ weaponObj.name }}<small v-if="weaponObj.tags.includes('martial')">&nbsp;✦</small></template>
    <template v-slot:subtitle>{{ subtitle }}</template>
    <template v-if="weaponObj.finesse" v-slot:abilitySmall>Finesse</template>

    <Text v-if="weaponObj.description">{{ weaponObj.description }}</Text>
    <Damage class="damage" :small="!!weaponObj.description">
      <template v-if="weaponObj.damage" v-slot:damage>{{ weaponObj.damage }}</template>
      <template v-if="weaponObj.twoHandDamage" v-slot:extraDamage>{{ weaponObj.twoHandDamage }}</template>
      <template v-if="weaponObj.damageType" v-slot:damageType>{{ weaponObj.damageType }}</template>
    </Damage>
    <Price>{{ weaponObj.price }}</Price>
  </BaseCard>
</template>

<script>
import { defineComponent, computed } from 'vue'

import BaseCard from '@/components/cards/BaseCard'
import Text from '@/components/cards/content/Text'
import Damage from '@/components/cards/content/Damage'
import Price from '@/components/cards/content/Price'

import cardProps from '@/helpers/cardProps'

import weaponList from '@/data/weapons'

export default defineComponent({
  props: {
    weapon: {
      type: String
    },

    ...cardProps
  },

  components: {
    BaseCard,
    Text,
    Damage,
    Price
  },

  setup (props) {
    const weaponObj = computed(() => weaponList[props.weapon])

    const subtitle = computed(() => {
      const parts = []
      if (weaponObj.value.tags.includes("melee")) {
        parts.push('Melee')
      }
      if (weaponObj.value.range) {
        parts.push(`Ranged ${weaponObj.value.range.distance} ft.`)
      }
      if (weaponObj.value.tags.includes("twoHand")) {
        if (weaponObj.value.tags.includes("oneHand")) parts.push(`(2-Hand)`)
        else parts.push(`2-Hand`)
      }
      return parts.join(', ')
    })

    return {
      weaponObj,
      subtitle,

      // Data
      weaponList
    }
  }
})
</script>

<style lang="sass">
.damage
  margin-top: -0.5rem
</style>
